import printComponent from './print.component';

let printModule = angular.module('print', [
	])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/routeSheet');

		$stateProvider
			.state('print', {
				url: '/print?route&date&branch&prefix',
				component: 'print',
				data: {
					requireLogin: true,
					requireACL: 'route_sheet.all'					
				},
			});
	})

	.component('print', printComponent)

	.name;

export default printModule;


// WEBPACK FOOTER //
// ./client/app/components/routeSheet/print/index.js